import { jsx as _jsx } from "react/jsx-runtime";
// 1. Ant Design
import { Button, Table, Tag, Tooltip, Typography } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { formatDate, formatMoney } from "./format";
const { Text } = Typography;
/** Таблица оплат компании (UC1120 §2.3, `v_corp_payments`). */
const PaymentsTable = observer(({ payments, loading, onVoidPayment }) => {
    const columns = [
        {
            title: "Дата платежа",
            key: "paidAt",
            render: (_, payment) => formatDate(payment.paidAt),
        },
        {
            title: "Сумма ₽",
            key: "amount",
            render: (_, payment) => formatMoney(payment.amount),
        },
        {
            title: "Документ",
            key: "doc",
            render: (_, payment) => payment.docNumber ? `${payment.docNumber} · ${formatDate(payment.docDate)}` : _jsx(Text, { type: "secondary", children: "\u2014" }),
        },
        {
            title: "Комментарий",
            key: "comment",
            render: (_, payment) => payment.comment ?? _jsx(Text, { type: "secondary", children: "\u2014" }),
        },
        {
            title: "Сторнирована",
            key: "isVoided",
            render: (_, payment) => payment.isVoided ? (_jsx(Tooltip, { title: payment.voidReason ?? "—", children: _jsx(Tag, { color: "red", children: "\u0441\u0442\u043E\u0440\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0430" }) })) : (_jsx(Text, { type: "secondary", children: "\u2014" })),
        },
        {
            title: "Действия",
            key: "actions",
            render: (_, payment) => !payment.isVoided && onVoidPayment ? (_jsx(Button, { size: "small", danger: true, "data-testid": "corp-payment-void", onClick: () => onVoidPayment(payment), children: "\u0421\u0442\u043E\u0440\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C" })) : (_jsx(Text, { type: "secondary", children: "\u2014" })),
        },
    ];
    return (_jsx("div", { "data-testid": "corp-settlements-payments-table", children: _jsx(Table, { rowKey: "paymentId", size: "middle", columns: columns, dataSource: payments, loading: loading, pagination: payments.length > 20 ? { pageSize: 20 } : false, scroll: { x: 900 }, locale: { emptyText: "Оплат пока нет" } }) }));
});
PaymentsTable.displayName = "PaymentsTable";
export default PaymentsTable;
